import React from "react";
import {
  Box,
  Typography,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  FormControl,
  Grid2,
} from "@mui/material";
import { Filter } from "./types";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface MultipleSelectFilterProps {
  filter: Filter;
  values: string[];
  onChange: (
    event: React.ChangeEvent<{ value: unknown }>,
    filter: Filter
  ) => void;
}

const MultipleSelectFilter: React.FC<MultipleSelectFilterProps> = ({
  filter,
  values,
  onChange,
}) => {
  return (
      <FormControl
        fullWidth
        sx={{
          minWidth: 200,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            mb: 1,
            fontWeight: 500,
            color: "#333",
          }}
        >
          {filter.label}
        </Typography>
        <Select
          labelId={`${filter.value}-label`}
          id={`${filter.value}-select`}
          multiple
          value={values}
          onChange={(e: any) => onChange(e, filter)}
          displayEmpty
          renderValue={(selected) => {
            if ((selected as string[]).length === 0) {
              return (
                <span style={{ color: "rgba(0, 0, 0, 0.6)" }}>
                  {filter.label}ทั้งหมด
                </span>
              );
            }

            if ((selected as string[]).length === 1) {
              const selectedOption = filter.options.find(
                (option) => option.value === (selected as string[])[0]
              );
              return selectedOption ? selectedOption.label : "";
            }

            return `เลือก ${(selected as string[]).length} ${filter.label}`;
          }}
          MenuProps={MenuProps}
        >
          {filter.options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              <Checkbox checked={values.indexOf(option.value) > -1} />
              <ListItemText primary={option.label} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
  );
};

export default MultipleSelectFilter;
